import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import './style.scss';

const Icon = ({ name, style, tooltipText, tooltipPlace, onClick }) => {
  return (
    <>
      <div data-tip={tooltipText} className={`icon-${name}-svg`} style={style} onClick={onClick}></div>
      {tooltipText && <ReactTooltip place={tooltipPlace} effect="solid" />}
    </>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  style: PropTypes.object,
  tooltipText: PropTypes.string,
  tooltipPlace: PropTypes.string,
  onClick: PropTypes.func,
};

Icon.defaultProps = {
  tooltipText: '',
  tooltipPlace: 'bottom',
  style: {},
  onClick: () => {},
};

export { Icon };
